import React from 'react';
import { Stack, Box, Button, Tooltip } from '@mui/material';
import FileViewer from '../components/FileViewer';
import { DataGrid, GridRowsProp, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';

const rows: GridRowsProp = [
  {
    id: 1,
    label: 'Reporte de resultados Líderes en Movimiento 2024',
    src: 'https://s3.us-east-1.amazonaws.com/lideresenmovimiento.s3/Reporte_LEM24_Vers-final.pdf',
    type: 'PDF',
    year: 2024,
  },
  {
    id: 2,
    label: 'Video final LeM Cuarta Generación 2024',
    src: 'https://s3.us-east-1.amazonaws.com/lideresenmovimiento.s3/LEM+24+Video+Recuento.mp4',
    type: 'Video',
    year: 2024,
  },
  {
    id: 3,
    label: 'Líderes en Movimiento. Primero resultados. 2020-2023 ',
    src: 'https://s3.us-east-1.amazonaws.com/lideresenmovimiento.s3/LeM+Video+Evento+CMN+(V3)+18012024.mp4',
    type: 'Video',
    year: 2024,
  },
  {
    id: 4,
    label: 'Reporte de resultados Líderes en Movimiento 2023',
    src: 'https://s3.amazonaws.com/lideresenmovimiento.s3/Fact-sheet+LEM-U+2020-21.pdf',
    type: 'PDF',
    year: 2023,
  },
  {
    id: 5,
    label: 'Video final LeM Tercera Generación 2023',
    src: 'https://s3.us-east-1.amazonaws.com/lideresenmovimiento.s3/VIDEO+CLAUSURA+-+L%C3%8DDERES+EN+MOVIMIENTO+2023+1080+HD.mp4',
    type: 'Video',
    year: 2023,
  },
  {
    id: 6,
    label: 'Reporte de resultados Líderes en Movimiento 2022',
    src: 'https://s3.us-east-1.amazonaws.com/lideresenmovimiento.s3/Reporte+de+Resultados+LeM+U+y+MS+2022.pdf',
    type: 'PDF',
    year: 2022,
  },
  {
    id: 7,
    label: 'Video final LeM Segunda Generación 2022',
    src: 'https://s3.us-east-1.amazonaws.com/lideresenmovimiento.s3/LeM+2022+Video+final.mp4',
    type: 'Video',
    year: 2022,
  },
  {
    id: 8,
    label: 'FactSheet Líderes en Movimiento Universitarios 2020-2021',
    src: 'https://s3.amazonaws.com/lideresenmovimiento.s3/Fact-sheet+LEM-U+2020-21.pdf',
    type: 'PDF',
    year: 2021,
  },
  {
    id: 9,
    label: 'La brecha de talento en México – Blanca Heredia y Edgar Franco, 2014',
    src: 'https://s3.amazonaws.com/lideresenmovimiento.s3/01.+La+brecha+de+talento+en+M%C3%A9xico+y+sus+costos+econ%C3%B3micos_BHyEF.pdf',
    type: 'PDF',
    year: 2014,
  },
  {
    id: 10,
    label:
      'Políticas públicas de atención a alumnos sobresalientes, Blanca Heredia, Alberto Serdán, Idalia Rodríguez y Daniela Rubio, 2015',
    src: 'https://s3.amazonaws.com/lideresenmovimiento.s3/02.+Pol%C3%ADticas+p%C3%BAblicas+alumnos+sobresalientes.pdf',
    type: 'PDF',
    year: 2015,
  },
  {
    id: 11,
    label: 'Reporte Resultados Líderes en Movimiento 2020 – 2021',
    src: 'https://s3.amazonaws.com/lideresenmovimiento.s3/Reporte+ejecutivo+LEM2020.pdf',
    type: 'PDF',
    year: 2021,
  },
  {
    id: 12,
    label: 'Video Primera generación',
    src: 'https://s3.amazonaws.com/lideresenmovimiento.s3/home_video2.mp4',
    type: 'Video',
    year: 2021,
  },
];

export default function Repositorio() {
  const [sortModel, setSortModel] = React.useState([{ field: 'label', sort: 'asc' }]);
  const [open, setOpen] = React.useState(false);
  const [selectedFile, setSelectedFile] = React.useState(null);

  const handleSelectFile = ({ row }) => {
    setSelectedFile(row);
    setOpen(true);
  };

  const columns: GridColDef[] = [
    {
      field: 'label',
      headerName: 'Nombre',
      flex: 1,
      minWidth: 260,
      renderCell: (params: GridRenderCellParams) => (
        <Box sx={{ cursor: 'default' }}>
          <Tooltip title={params.value}>
            <Box
              component="span"
              sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
              aria-label={params.value}
            >
              {params.value}
            </Box>
          </Tooltip>
        </Box>
      ),
    },
    { field: 'type', headerName: 'Tipo', width: 90 },
    { field: 'year', headerName: 'Año', width: 90 },
    {
      field: 'open',
      headerName: '',
      renderCell: (params: GridRenderCellParams) => (
        <Button
          variant="contained"
          color="primary"
          tabIndex={0}
          size="small"
          aria-label={`Abrir archivo: ${params.value}`}
          style={{ marginLeft: 16 }}
          onClick={() => handleSelectFile(params)}
        >
          Abrir
        </Button>
      ),
    },
  ];

  return (
    <Stack
      component="main"
      aria-labelledby="label"
      alignItems="center"
      sx={{
        py: 5,
        px: '5%',
        flexGrow: 1,
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Box id="label" sx={{ typography: 'h4', fontWeight: 'bold', color: '#3E3D3D', mb: 2 }}>
        Repositorio
      </Box>
      <Stack sx={{ maxWidth: '1200px', width: '100%', boxSizing: 'border-box' }} flexGrow={1}>
        <DataGrid
          columns={columns}
          rows={rows}
          sortModel={sortModel}
          onSortModelChange={(model) => setSortModel(model)}
          hideFooter
          disableColumnMenu
          disableVirtualization
          experimentalFeatures={{ keyboardNavigation: true }}
        />
        {open && (
          <FileViewer
            open={open}
            setOpen={setOpen}
            src={selectedFile.src}
            label={selectedFile.label}
            type={selectedFile.type}
          />
        )}
      </Stack>
    </Stack>
  );
}
